import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { getProject } from 'project/ducks/project';
import { rate, toggleDelete } from 'entries/ducks';
import {
  isAtYourEntries, canViewRating, canViewNewTag, canRate, canWithdraw, canEliminate,
  canViewAwardValue, canViewTipValue, canViewOfferValue, canViewDescription,
  canViewAssetPrice, canFilterByCreative
} from 'entries/utils';
import ImageNameTile from 'entries/components/image_name_tile';

export const mapStateToProps = (state, { routes, item }) => {
  const user = state.user.profile_data;
  const entry = item;
  const project = getProject(state);
  const atYourEntries = isAtYourEntries({ routes });

  return {
    canViewRating: canViewRating({ user, project, entry, atYourEntries }),
    canViewNewTag: canViewNewTag({ user, project }),
    canRate: canRate({ user, project, entry }),
    canDelete: canWithdraw({ entry, user }) || canEliminate({ entry, user, project }),
    canViewAwardValue: canViewAwardValue({ entry, user, project }),
    canViewTipValue: canViewTipValue({ entry, user, project }),
    canViewOfferValue: canViewOfferValue({ entry, user, project }),
    canViewDescription: canViewDescription({ entry, user, project }),
    canViewAssetPrice: canViewAssetPrice({ entry, user, project }),
    canFilterByCreative: canFilterByCreative({ user, project }),
    project
  };
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    onRate: rate,
    onDelete: toggleDelete
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImageNameTile));



// WEBPACK FOOTER //
// ./entries/containers/image_name_tile.js